export const getAllChildNodes = (root) => {
  if (!root) {
    return []
  }

  const nodes = []

  function traverse(node) {
    if (node.childOptions) {
      node.childOptions.forEach((child) => {
        nodes.push(child.id)
        if (child.childOptions) {
          traverse(child)
        }
      })
    }
  }

  traverse(root)
  return nodes
}

export const getCheckedStateByChildren = (root, value) => {
  if (value.includes(root.id)) {
    return 'all'
  }

  const stack = [root]
  let foundChecked = false
  let foundUnchecked = false
  let state = 'none'

  while (stack.length) {
    const parent = stack.pop()
    const children = parent.childOptions || []

    for (let i = 0; i < children.length; i += 1) {
      const child = children[i]
      if (value.includes(child.id)) {
        foundChecked = true
      } else {
        foundUnchecked = true
      }

      if (foundChecked && foundUnchecked) {
        return 'some'
      }
      if (foundChecked && !foundUnchecked) {
        state = 'all'
      }

      if (child.childOptions) {
        stack.push(child)
      }
    }
  }

  return state
}

export const mapDataFromApi = (data) => {
  if (
    !data ||
    !data.attributes ||
    !data.attributes.uuid ||
    !data.attributes.path
  ) {
    return []
  }

  const tree = []

  function traverse(node, parentNode = null) {
    const dirName = node.attributes.path
    const title = dirName.substr(dirName.lastIndexOf('/') + 1)
    const path = parentNode ? [...parentNode.path, parentNode] : []

    const newNode = {
      id: node.attributes.uuid,
      title,
      icon: 'folder-directory',
      path,
      childOptions: [],
    }

    const children = node.relationships ? node.relationships.children : []
    children.forEach((child) => {
      newNode.childOptions.push(traverse(child, newNode))
    })

    if (parentNode && !parentNode.path.length) {
      tree.push(newNode)
    }

    return newNode
  }

  traverse(data)
  return tree
}
